import { createContext } from 'react';
import type { AuthUser, LoginResponse, RegisterInput, RegisterResponse } from '@teentack/shared';

export interface AuthContextValue {
  user: AuthUser | null;
  /** True until the initial refresh-token check has settled. */
  initializing: boolean;
  login: (identifier: string, password: string) => Promise<LoginResponse>;
  register: (input: RegisterInput) => Promise<RegisterResponse>;
  verifyOtp: (identifier: string, code: string) => Promise<AuthUser>;
  logout: () => Promise<void>;
  reload: () => Promise<void>;
}

/** Lives apart from the provider so the provider file only exports components. */
export const AuthContext = createContext<AuthContextValue | null>(null);
